<template>
  <div class="form-block">
    <h1
      v-if="title"
      class="form-block__title">{{ title }}</h1>
    <p
      v-if="description"
      class="form-block__description">{{ description }}</p>
    <JsonSchema
      ref="jsonSchema"
      :key="resetKey"
      v-model="formValue"
      :schema="formSchema"
      :components="componentsConfig"
      :ui-schema="uiSchema"
      :wrapper="wrapperComponentConfig"
      @init-default="initDefault"
      @input="() => {}" />

    <!-- <pre>{{  formHasAChange }}</pre>
    <pre>{{ initFormValue }}</pre> -->
  </div>
</template>

<script>
import JsonSchema from '@roma219/vue-jsonschema-form';
import FormSchemaMixin from './FormSchema.mixin';

export default {
  name: 'FormBlock',
  components: {
    JsonSchema,
  },
  mixins: [
    FormSchemaMixin,
  ],
  props: {
    formSchema: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    title: {
      type: String,
      required: true,
      default: '',
    },
    description: {
      type: String,
      required: true,
      default: '',
    },
    value: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      formValue: {},
      initFormValue: {},
      resetKey: 0,
    };
  },
  computed: {
    returnData() {
      const formData = {};
      if (Object.keys(this.formValue).length) {
        Object.keys(this.formValue).forEach((key) => {
          formData[key] = (this.formValue[key] && this.formValue[key].data && !(this.formValue[key].data.value === undefined || this.formValue[key].data.value === null)) ? this.formValue[key].data.value : undefined;
        });
      }
      return formData;
    },
    formHasAChange() {
      return !this.$lodash.isEqual(JSON.parse(JSON.stringify(this.initFormValue)), JSON.parse(JSON.stringify(this.returnData)));
    },
  },
  watch: {
    formValue: {
      handler(newVal) {
        this.$emit('input', this.returnData);
        this.emitInfo();
      },
      deep: true,
    },
    formSchema: {
      handler(newVal) {
        // console.log('formSchema changed', newVal);
        this.resetForm();
        setTimeout(() => {
          this.$set(this, 'initFormValue', JSON.parse(JSON.stringify(this.returnData)));
          this.emitInfo();
        }, 200);
      },
      deep: true,
    },
  },
  mounted() {
    this.initFormValue = JSON.parse(JSON.stringify(this.value));

    this.$nextTick(() => {
      Object.keys(this.formSchema.properties).forEach((key) => {
        this.initFormValue[key] = this.value[key] && this.value[key].data && this.value[key].data.value ? this.value[key].data.value : this.formSchema.properties[key] && this.formSchema.properties[key].value ? this.formSchema.properties[key].value : '';
      });
    });
  },
  methods: {
    // Add any methods needed
    resetForm() {
      this.resetKey++;
    },
    emitInfo() {
      this.$emit('info', {
        valid: Object.values(this.formValue).every(value => value.valid),
        hasChanges: this.formHasAChange,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.form-block {
  &__title {
    font-size: 18px;
    font-weight: bold;
    color: $blackPrimary;
    margin-bottom: 5px;
  }
  &__description {
    line-height: 1.37;
    font-size: 14px;
    color: $blackUltralight;
  }
  .json-schema-form {
    margin-top: 18px;
  }
}
</style>
